import React from 'react';
import { DefaultLayout } from '../layouts/example';
import {
	exampleMainPage,
	ibsheetPage,
	apiPage,
	kuploadPage,
	reportPage,
	uiPage,
	file,
	esign,
	pass,
	sms
} from '../publish/example/';

export type PageRouteProps = {
	path: string;
	component: React.ComponentType<any>;
	layout: React.ComponentType<any>;
};
export const routes: Array<PageRouteProps> = [
	{
		path: '/example',
		component: exampleMainPage,
		layout: DefaultLayout,
	},

	// 사용자관리 [4000]
	{
		path: '/example/api',
		component: apiPage,
		layout: DefaultLayout,
	},
	{
		path: '/example/ibsheet',
		component: ibsheetPage,
		layout: DefaultLayout,
	},
	{
		path: '/example/kupload',
		component: kuploadPage,
		layout: DefaultLayout,
	},
	{
		path: '/example/report',
		component: reportPage,
		layout: DefaultLayout
	},
	{
		path: '/example/ui',
		component: uiPage,
		layout: DefaultLayout
	},
	{
		path: '/example/file',
		component: file,
		layout: DefaultLayout
	},
	{
		path: '/example/esign',
		component: esign,
		layout: DefaultLayout
	},
	{
		path: '/example/pass',
		component: pass,
		layout: DefaultLayout
	},
	{
		path: '/example/sms',
		component: sms,
		layout: DefaultLayout
	}
];